import React from "react";
import "./ConstruccionCivil.css"; 
import gestionImg from "../assets/images/gestion.jpg";
import pdfMalla from "../assets/docs/gestion.pdf";
import { FaBriefcase, FaDownload } from "react-icons/fa";

const GestionAdministrativa = () => {
  return (
    <section className="carrera-detalle">
      {/*  Banner  */}
      <div
        className="carrera-hero-modern"
        style={{ backgroundImage: `url(${gestionImg})` }}
      >
        <div className="carrera-hero-overlay">
          <h1 className="fw-bold">Gestión Administrativa</h1>
          <p>
            Formamos profesionales técnicos capaces de planificar, organizar y
            dirigir procesos administrativos con liderazgo e innovación.
          </p>
        </div>
      </div>

      {/*  Contenido principal */}
      <div className="container my-5">
        <div className="row g-4">
  
          <div className="col-lg-8">
            <div className="info-card p-4 shadow-sm rounded-4 bg-white">
              <h3 className="text-primary fw-bold mb-3">
                <FaBriefcase className="me-2" />
                TÍTULO: PROFESIONAL TÉCNICO EN GESTIÓN ADMINISTRATIVA
              </h3>

              <h5 className="fw-bold text-primary mt-4">
                DESCRIPCIÓN DEL PERFIL DE EGRESO
              </h5>
              <p>
                El profesional técnico del programa de estudios de Gestión
                Administrativa del Instituto de Educación Superior Tecnológico
                Público "Gilda Liliana Ballivián Rosado", tiene competencias
                para elaborar procedimientos administrativos; definir el
                presupuesto del plan de actividades administrativas y de apoyo;
                disponer servicios especializados; administrar recursos humanos,
                materiales y financieros; y supervisar el cumplimiento del plan
                operativo institucional en función de las políticas, objetivos y
                normativa correspondiente.
              </p>
              <p>
                Además, se desempeña éticamente, comunicándose eficazmente,
                utilizando tecnologías de información, fomentando la innovación,
                el emprendimiento y el liderazgo en organizaciones públicas o
                privadas.
              </p>

              <h5 className="fw-bold text-primary mt-4">
                COMPETENCIA GENERAL
              </h5>
              <p>
                La carrera de Gestión Administrativa forma profesionales
                capaces de planificar, organizar, dirigir y controlar los
                procesos administrativos de una organización con eficiencia y
                responsabilidad.
              </p>

              <h5 className="fw-bold text-primary mt-4">
                CAMPOS DE ACCIÓN EN LOS QUE SE INSERTAN LOS EGRESADOS
              </h5>
              <p>
                El egresado podrá desempeñarse en diversas áreas
                organizacionales, tanto en el sector público como en el
                privado:
              </p>
              <ul>
                <li>Área de Administración</li>
                <li>Área de Logística</li>
                <li>Área de Recursos Humanos</li>
                <li>Área de Proyectos Empresariales</li>
                <li>Área de Marketing</li>
                <li>Área de Finanzas y Contabilidad</li>
                <li>Área de Comercio Exterior</li>
                <li>Área de Atención al Cliente y Asesoría Empresarial</li>
              </ul>

              <h5 className="fw-bold text-primary mt-4">
                COMPETENCIAS ESPECÍFICAS
              </h5>
              <ul>
                <li>
                  Elaborar procedimientos administrativos conforme a los
                  objetivos de la organización.
                </li>
                <li>
                  Definir presupuestos según planes y actividades de apoyo.
                </li>
                <li>
                  Administrar recursos humanos, materiales y financieros según
                  políticas internas.
                </li>
                <li>
                  Supervisar el cumplimiento del plan operativo institucional.
                </li>
                <li>
                  Disponer servicios especializados de acuerdo con la normativa
                  vigente.
                </li>
              </ul>

              <h5 className="fw-bold text-primary mt-4">PUESTOS DE TRABAJO</h5>
              <ul>
                <li>Administrador de personal</li>
                <li>Analista de créditos y cobranzas</li>
                <li>Técnico en logística o producción</li>
                <li>Analista de comercio exterior</li>
                <li>Supervisor o analista de recursos humanos</li>
                <li>Administrador de gestión financiera</li>
                <li>Asistente administrativo o docente</li>
              </ul>

              <h5 className="fw-bold text-primary mt-4">
                SALIDA HACIA OTROS ESTUDIOS
              </h5>
              <ul>
                <li>Licenciatura en Administración</li>
                <li>Ingeniería Administrativa</li>
                <li>Gestión Empresarial</li>
                <li>Docencia o especialización en gestión pública</li>
              </ul>
            </div>
          </div>

          {/*  Panel lateral */}
          <div className="col-lg-4">
            <div className="sidebar-card p-4 rounded-4 shadow-sm text-center bg-white">
              <img
                src={gestionImg}
                alt="Gestión Administrativa"
                className="img-fluid rounded-3 mb-3"
              />
              <a
                href={pdfMalla}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-download w-100"
              >
                <FaDownload className="me-2" /> Descargar Malla Curricular 2024
                (PDF)
              </a>
              <div className="mt-4 text-start">
                <h6 className="text-primary fw-bold">DURACIÓN</h6>
                <p className="mb-2">
                  Seis semestres equivalentes a tres años académicos.
                </p>
                <h6 className="text-primary fw-bold">TURNOS DE ESTUDIO</h6>
                <p className="mb-0">Diurno - 8:00 a.m. a 1:00 p.m.</p>
                <p className="mb-0">Nocturno - 6:00 p.m. a 10:20 p.m.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GestionAdministrativa;
